// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The single full-screen loader for the Wix entry + onboarding. Identical to the
   old WixOnboarding \`.wxo-page-loader\`, but shared so App.js (resolving the Wix
   instance) and WixOnboarding show the SAME purple loader with no white flash or
   flicker between them. */
.wel-screen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  overflow: hidden;
  display: grid;
  place-items: center;
  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);
}

/* faint diagonal grid that fades toward the bottom — matches the onboarding brand
   visual (.wav-grid) */
.wel-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);
  pointer-events: none;
}
/* light bloom in the top-right corner — matches .wav-glow */
.wel-glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(58% 42% at 80% 8%, rgba(255, 255, 255, 0.17), transparent 62%);
  pointer-events: none;
}

.wel-stack {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}
.wel-text {
  margin: 0;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.92);
}
.wel-ring {
  width: 54px;
  height: 54px;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: wel-spin 0.8s linear infinite;
}
@keyframes wel-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .wel-ring { animation-duration: 2.4s; } }
`, "",{"version":3,"sources":["webpack://./src/components/WixEntryLoader.css"],"names":[],"mappings":"AAAA;;;0BAG0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;uBACuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,0EAA0E;EAC1E,oBAAoB;AACtB;AACA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;AACxD,0CAA0C,YAAY,wBAAwB,EAAE,EAAE","sourcesContent":["/* The single full-screen loader for the Wix entry + onboarding. Identical to the\r\n   old WixOnboarding `.wxo-page-loader`, but shared so App.js (resolving the Wix\r\n   instance) and WixOnboarding show the SAME purple loader with no white flash or\r\n   flicker between them. */\r\n.wel-screen {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 9999;\r\n  overflow: hidden;\r\n  display: grid;\r\n  place-items: center;\r\n  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);\r\n}\r\n\r\n/* faint diagonal grid that fades toward the bottom — matches the onboarding brand\r\n   visual (.wav-grid) */\r\n.wel-grid {\r\n  position: absolute;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);\r\n  background-size: 34px 34px;\r\n  -webkit-mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);\r\n  mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);\r\n  pointer-events: none;\r\n}\r\n/* light bloom in the top-right corner — matches .wav-glow */\r\n.wel-glow {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: radial-gradient(58% 42% at 80% 8%, rgba(255, 255, 255, 0.17), transparent 62%);\r\n  pointer-events: none;\r\n}\r\n\r\n.wel-stack {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 22px;\r\n}\r\n.wel-text {\r\n  margin: 0;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.01em;\r\n  color: rgba(255, 255, 255, 0.92);\r\n}\r\n.wel-ring {\r\n  width: 54px;\r\n  height: 54px;\r\n  border: 3px solid rgba(255, 255, 255, 0.25);\r\n  border-top-color: #fff;\r\n  border-radius: 50%;\r\n  animation: wel-spin 0.8s linear infinite;\r\n}\r\n@keyframes wel-spin { to { transform: rotate(360deg); } }\r\n@media (prefers-reduced-motion: reduce) { .wel-ring { animation-duration: 2.4s; } }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
